import React, { useEffect, useRef, useState } from "react"
import Tag from "../UI/Tag/tag"
import ReactMarkdown from "react-markdown"
import rehypeRaw from "rehype-raw"
import LinkButton from "../UI/LinkButton/link-button"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import { getYouTubeEmbedUrl } from "../../../utils/gatsby-helpers"

const Channels = ({ channels }) => {
    const [video, setVideo] = useState(null)
    const [showVideoModal, setShowVideoModal] = useState(false)
    const [visibleElements, setVisibleElements] = useState({})
    const channelRefs = useRef([])

    const openVideoModal = (video) => {
        setVideo(video)
        setShowVideoModal(true)
    }

    useEffect(() => {
        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    const index = entry.target.getAttribute("data-index")
                    setVisibleElements((prev) => ({ ...prev, [index]: true }))
                    observer.unobserve(entry.target)
                }
            })
        }, { threshold: 0.2 })

        channelRefs.current.forEach((ref) => {
            ref && observer.observe(ref)
        })

        return () => observer.disconnect()
    }, [channels])

    return (
        <>
            {channels.map((channel, index) => {
                const isEven = index % 2 === 0
                const isVisible = visibleElements[index]

                return (
                    <div
                        key={index}
                        className={`main__section main__section--50-overflow ${!isEven ? 'main__section--50-overflow-invert' : ''}`}
                    >
                        <div className="container">
                            <div className="container__50">
                                <div className="tag-group ai-flex-start">
                                    {channel.tags?.map((tag, tIndex) => (
                                        <Tag key={tIndex} tag={tag} />
                                    ))}
                                </div>
                                <h2>{channel.title}</h2>
                                <div className="container__text">
                                    <ReactMarkdown children={channel.description} rehypePlugins={[rehypeRaw]} />
                                </div>
                                <LinkButton button={channel.button} className="button button--xl" />
                            </div>

                            <div className="container__overflow">
                                {channel.video ?
                                    <div
                                        ref={(el) => (channelRefs.current[index] = el)}
                                        data-index={index}
                                        className={`container__overflow__media ${isVisible ? 'show' : ''}`}
                                    >
                                        <GatsbyImage
                                            alt={channel.video?.video_preview?.alternativeText || "Video preview"}
                                            image={getImage(channel.video?.video_preview?.localFile)}
                                        />
                                        <div onClick={() => openVideoModal(channel.video)} className="button-icon">
                                            <i className="icon-play"></i>
                                        </div>
                                    </div>
                                    :
                                    <div
                                        ref={(el) => (channelRefs.current[index] = el)}
                                        data-index={index}
                                        className={`container__overflow__image ${isVisible ? 'show' : 'show-start'}`}
                                    >
                                        <GatsbyImage alt={channel.image.alternativeText || 'Image preview'} image={getImage(channel.image.localFile)} />
                                    </div>    
                                }
                            </div>
                        </div>
                    </div>
                )
            })}

            {showVideoModal &&
                <div className="tc-modal">
                    <div className="tc-modal__content">
                        <div className="tc-modal__content__header">
                            <button className="button-icon button-icon--sm" onClick={() => setShowVideoModal(false)}>
                                <i className="icon-close"></i>
                            </button>
                        </div>
                        <div className="tc-modal__content__body">
                            <iframe
                                loading="lazy"
                                src={getYouTubeEmbedUrl(video.video_url)}
                                title="YouTube video player"
                                frameBorder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                referrerpolicy="strict-origin-when-cross-origin"
                                allowFullScreen
                            />
                        </div>
                    </div>
                </div>
            }
        </>
    )
}

export default Channels
